import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  OnChanges
} from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { CpmService } from 'app/service/cpm.service'
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from 'environments/environment'
import { CrmContinueActionComponent } from 'app/crm/crm-continue-action/crm-continue-action.component'
import { SetAttendeesComponent } from '../set-attendees/set-attendees.component'
import { ContinueCaseSelectBoxComponent } from '../continue-case-select-box/continue-case-select-box.component'
import { CompanyAttendeesComponent } from '../company-attendees/company-attendees.component'
import { StatusComponent } from '../status/status.component'
import { AuthorizeService } from '../../service/authorize.service'

@Component({
  selector: 'app-crm-edit-case',
  templateUrl: './crm-edit-case.component.html',
  styleUrls: ['./crm-edit-case.component.scss']
})
export class CrmEditCaseComponent implements OnInit, OnChanges {
  @Input() editId
  @Output() onFinished: EventEmitter<any> = new EventEmitter()

  @ViewChild('template') template: TemplateRef<any>
  @ViewChild('continueCaseSelectBoxComponent')
  continueCaseSelectBoxComponent: ContinueCaseSelectBoxComponent
  @ViewChild('setAttendeesComponent')
  setAttendeesComponent: SetAttendeesComponent
  @ViewChild('companyAttendeesComponent')
  companyAttendeesComponent: CompanyAttendeesComponent
  @ViewChild('continueActionComponent')
  continueActionComponent: CrmContinueActionComponent
  @ViewChild('statusComponent') statusComponent: StatusComponent

  modalRef: BsModalRef

  searchContinueCaseResults: Array<Object> = []
  meetingObjectiveList: Array<Object> = []
  setEmployeeList: Array<Object> = []
  statusList: Array<Object> = []
  departmentList: Array<Object> = []

  employeeSearchResult: Array<Object> = []
  companyContactList: Array<Object> = []
  validation_message

  presentationFile: File = null
  factsheetFile: File = null
  memoFile: File = null

  oldPresentationFile = null
  oldFactsheetFile = null
  oldMemoFile = null
  displayCaseSearch = true
  updateMemoFlag = false

  iframeSource

  isFormValid: Boolean = true

  caseInformation
  securityProfile
  caseForm: FormGroup = new FormGroup({})

  constructor(
    private cpmService: CpmService,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private authorization: AuthorizeService
  ) { }

  ngOnChanges() {
    this.buildForm()
    this.initialData()
  }

  ngOnInit() { }

  async getCommonData() {
    await Promise.all([
      this.cpmService.getCaseStatusList(),
      this.cpmService.getMeetingObjective(),
      this.cpmService.getEmployeeList()
    ]).then(
      ([
        statusListResponse,
        meetingObjectiveListResponse,
        employeeListResponse
      ]) => {
        this.statusList = statusListResponse
        this.meetingObjectiveList = meetingObjectiveListResponse
        this.setEmployeeList = employeeListResponse
      }
    )
  }

  buildForm(): void {
    this.caseForm = this.fb.group({
      meetingObjectiveControl: [''],
      summaryControl: ['', Validators.required],
      otherAttendee: [''],
      presentationFileSelectInput: [null],
      factsheetFileSelectInput: [null],
      memoFileSelectInput: [null],
      jointDepartment: [{ value: '', disabled: true }],
      caseStatus: [''],
      department: [''],
      serviceStartTime: ['', Validators.compose([
        Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')
      ])],
      serviceEndTime: ['', Validators.compose([
        Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')
      ])],
    })
  }

  get serviceStartTime() { return this.caseForm.get('serviceStartTime'); }
  get serviceEndTime() { return this.caseForm.get('serviceEndTime'); }

  async fetchingSecurityCase() {
    await this.cpmService
      .getCrmCaseById(this.editId)
      .toPromise()
      .then(response => {
        this.caseInformation = response
      })
    await this.getCommonData()
    await Promise.all([
      this.cpmService.getCrmCase(
        this.caseInformation.securitySymbol,
        'securitySymbol'
      ),
      this.cpmService.getSecurityProfile(this.caseInformation.securitySymbol),
      this.cpmService.getCompanyContactList(
        this.caseInformation.securitySymbol
      ),
      this.cpmService.getForwardingDepartment(
        this.caseInformation.securitySymbol
      ),
      this.cpmService.getAEList(this.caseInformation.securitySymbol)
    ]).then(
      ([
        continueCaseResponse,
        securityProfileResponse,
        companyContactResponse,
        forwardingDepartmentResponse,
        symbolAEList
      ]) => {
        this.searchContinueCaseResults = continueCaseResponse
        this.securityProfile = securityProfileResponse
        this.companyContactList = companyContactResponse
        this.departmentList = this.getDepartmentWithAEName(
          forwardingDepartmentResponse,
          symbolAEList
        )
      }
    )
  }

  async initialData() {
    await this.fetchingSecurityCase()
    if (!this.caseInformation) {
      return
    }

    if (this.isContinueCase()) {
      this.continueCaseSelectBoxComponent.searchContinueCaseResults = this.searchContinueCaseResults
      this.continueCaseSelectBoxComponent.continueCaseId = this.caseInformation.continueCaseId
      this.continueCaseSelectBoxComponent.editingCaseId = this.caseInformation.caseId
      this.continueCaseSelectBoxComponent.initial()
    }

    this.caseForm
      .get('meetingObjectiveControl')
      .setValue(this.caseInformation.meetingObjectiveId)
    this.oldPresentationFile = this.caseInformation.presentationFile
    this.oldFactsheetFile = this.caseInformation.factsheetFile
    this.oldMemoFile = this.caseInformation.memoFile
    this.caseForm.get('summaryControl').setValue(this.caseInformation.summary)
    this.caseForm
      .get('jointDepartment')
      .setValue(this.caseInformation.jointDepartmentFlag)
    this.caseForm
      .get('otherAttendee')
      .setValue(this.caseInformation.otherAttendee)
    this.caseForm
      .get('serviceStartTime')
      .setValue(this.caseInformation.serviceStartTime)
    this.caseForm
      .get('serviceEndTime')
      .setValue(this.caseInformation.serviceEndTime)
    this.setAttendeeSetting()
    this.companyAttendeeSetting()
    this.continueActionSetting()
    this.statusSetting()
    this.disableFormControlIfNotPermitted()
  }

  changeJointDepartment(event): void {
    this.caseForm.get('jointDepartment').setValue(event)
  }

  setAttendeeSetting(): void {
    this.setAttendeesComponent.setEmployeeList = this.setEmployeeList
    this.setAttendeesComponent.attendee = this.caseInformation.setAttendee
    this.setAttendeesComponent.initialEdit()
  }

  companyAttendeeSetting(): void {
    this.companyAttendeesComponent.companyContactList = this.companyContactList
    this.companyAttendeesComponent.attendee = this.caseInformation.companyAttendee
    this.companyAttendeesComponent.initialEdit()
  }

  continueActionSetting(): void {
    this.continueActionComponent.continueActions = this.caseInformation.continueAction
    this.continueActionComponent.initial()
  }

  statusSetting(): void {
    this.statusComponent.statusList = this.statusList
    this.statusComponent.departmentList = this.departmentList
    this.statusComponent.statusId = this.caseInformation.caseStatusId
    this.statusComponent.departmentId = this.caseInformation.continueDepartmentId
    this.statusComponent.isCreateNewCase = false
    this.statusComponent.enableEditStatus = this.canBeEnableEditStatus()
    this.statusComponent.initial()
  }

  canBeEnableEditStatus() {
    const continueActionArray = this.caseInformation.continueAction
    if (continueActionArray.length > 0) {
      const lastestContinueAction =
        continueActionArray[continueActionArray.length - 1]
      return lastestContinueAction.employeeId === this.authorization.getUserId()
    }
    return true
  }

  getDepartmentWithAEName(department, symbolAEList): Array<Object> {
    return department.map(x => {
      const ae = symbolAEList.find(e => e.department === x.shortName)
      x['aeName'] = ae.firstNameThai + ' ' + ae.lastNameThai
      return x
    })
  }

  onTimeInput(event) {
    event.target.value = event.target.value.replace(/[^\d\:]+/g, '')
  }

  get securitySymbol(): String {
    return this.caseInformation === undefined
      ? ''
      : this.caseInformation.securitySymbol
  }

  get companyNameThai(): String {
    return this.caseInformation === undefined
      ? ''
      : this.caseInformation.companyNameThai
  }

  get meetingDate(): String {
    return this.caseInformation === undefined
      ? ''
      : this.caseInformation.meetingDate
  }

  get caseType(): String {
    if (this.caseInformation !== undefined) {
      return this.caseInformation.type === 'C' ? 'Continue case' : 'New case'
    }
    return null
  }

  get castId(): String {
    if (this.caseInformation !== undefined) {
      return this.caseInformation.caseId === undefined
        ? '[New Case]'
        : this.caseInformation.caseId
    }
    return null
  }

  isContinueCase(): Boolean {
    return this.caseInformation === undefined
      ? false
      : this.caseInformation.type === 'C'
  }

  prepareData(): FormData {
    const formData = new FormData()
    if (this.presentationFile) {
      formData.append('presentationFile', this.presentationFile)
    }
    if (this.factsheetFile) {
      formData.append('factsheetFile', this.factsheetFile)
    }
    if (this.memoFile) {
      formData.append('memoFile', this.memoFile)
    }
    formData.append(
      'crmCase',
      new Blob(
        [
          JSON.stringify({
            caseStatusId: this.statusComponent.currentStatus,
            continueDepartmentId: this.statusComponent.currentDepartment,
            companyIdPsims: this.securityProfile.companyIdPsims,
            id: this.checkNewCaseOrContinueCase(this.caseInformation.id), // id === null is add new case
            continueCaseId: this.getContinueCaseId(),
            jointDepartmentFlag: this.caseForm.get('jointDepartment').value,
            meetingDate: this.getDateISO(this.caseInformation.meetingDate),
            meetingObjectiveId: this.caseForm.get('meetingObjectiveControl')
              .value,
            summary: this.caseForm.get('summaryControl').value,
            type: this.caseInformation.type,
            setAttendee: this.setAttendeesComponent.getAllSetAttendees,
            companyAttendee: this.companyAttendeesComponent
              .getAllCompanyAttendees,
            otherAttendee: this.caseForm.get('otherAttendee').value,
            updateMemo: this.updateMemoFlag, // true iff browse some memo file
            continueAction: this.computeContinueAction, // seq === null is add new continue action
            serviceStartTime: this.caseForm.get('serviceStartTime').value,
            serviceEndTime: this.caseForm.get('serviceEndTime').value
          })
        ],
        { type: 'application/json' }
      )
    )
    return formData
  }

  async onSubmit() {
    this.isFormValid = this.validateForm()
    if (!this.isFormValid) {
      return
    }
    if (this.caseInformation) {
      await this.cpmService
        .putCaseData(this.prepareData())
        .then(response => {
          this.finished(response)
        })
        .catch(() => {
          this.finished({
            message: 'Something wrong when try to save.',
            status: 'ERROR'
          })
        })
    } else {
      alert('Something went wrong!')
    }
  }

  finished(response): void {
    if (response) {
      this.onFinished.emit(response)
    } else {
      this.onFinished.emit({ message: 'Cancel action.', status: 'WARNNING' })
    }
  }

  validateForm(): Boolean {
    if (this.caseInformation.caseOwnerFlag !== 'Y') {
      return true
    }

    if (this.caseForm.valid) {
      return true
    }

    return false
  }

  checkNewCaseOrContinueCase(id): Number {
    if (id === undefined) {
      return null
    }
    return id
  }

  getDateISO(date): String {
    return new Date(date).toISOString()
  }

  changePresentation(event): void {
    if (event.target.files.length > 0) {
      this.presentationFile = event.target.files[0]
    }
  }

  changeFactsheet(event): void {
    if (event.target.files.length > 0) {
      this.factsheetFile = event.target.files[0]
    }
  }

  changeMemo(event): void {
    if (event.target.files.length > 0) {
      this.updateMemoFlag = true
      this.memoFile = event.target.files[0]
    }
  }

  get computeContinueAction(): Array<Object> {
    const arrayOfAction = this.continueActionComponent.actionFormGroupArray
      .value as Array<Object>
    return arrayOfAction
      .filter(x => x['seq'] !== null)
      .map(x => Object({ seq: x['seq'], action: x['action'] }))
  }

  getContinueCaseId(): Number {
    if (this.isContinueCase()) {
      return this.continueCaseSelectBoxComponent.getContinueCaseId()
    }
    return null
  }

  get getPresentationFile(): Object {
    if (this.presentationFile) {
      return {
        fileName: this.presentationFile.name,
        fileItem: this.presentationFile
      }
    }
    return { fileName: 'No file was chosen.', fileItem: null }
  }

  get getFactsheetFile(): Object {
    if (this.factsheetFile) {
      return {
        fileName: this.factsheetFile.name,
        fileItem: this.factsheetFile
      }
    }
    return { fileName: 'No file was chosen.', fileItem: null }
  }

  get getMemoFile(): Object {
    if (this.memoFile) {
      return { fileName: this.memoFile.name, fileItem: this.memoFile }
    }
    return { fileName: 'No file was chosen.', fileItem: null }
  }

  generateModal(fileItem): void {
    this.readFile(fileItem).then(result => {
      const iframe = document.querySelector('iframe')
      const resultAsString = result.toString()
      iframe.src = resultAsString
      if (
        resultAsString.startsWith('data:application/pdf') ||
        resultAsString.startsWith('data:image')
      ) {
        return
      }
      setTimeout(this.modalRef.hide, 200)
    })
  }

  readFile(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader()
      fr.onload = () => {
        resolve(fr.result)
      }
      fr.readAsDataURL(file)
    })
  }

  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }

  closeModal(): void {
    this.modalRef.hide()
  }

  previewFile(fileForPreview): void {
    this.openModal(this.template)
    switch (fileForPreview) {
      case 'presentation': {
        this.generateModal(this.presentationFile)
        break
      }
      case 'factsheet': {
        this.generateModal(this.factsheetFile)
        break
      }
      case 'memo': {
        this.generateModal(this.memoFile)
        break
      }
      case 'oldPresentationFile': {
        this.oldPresentation(this.caseInformation.id)
        break
      }
      case 'oldFactsheetFile': {
        this.oldFactsheet(this.caseInformation.id)
        break
      }
      case 'oldMemoFile': {
        this.oldMemo(this.caseInformation.id)
        break
      }
    }
  }

  closeModalWithFileTypeCondition(arrayContainsFileType): void {
    setTimeout(
      function (modal) {
        if (!arrayContainsFileType) {
          setTimeout(modal.hide, 200)
        }
      },
      200,
      this.modalRef
    )
  }

  oldPresentation(id): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    const array = this.oldPresentationFile.split('.')
    const openableFormat = ['jpg', 'gif', 'pdf', 'png'];
    const arrayContainsFileType = (openableFormat.indexOf(array[array.length - 1].toLowerCase()) > -1);
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_presentation&id=${id}`
    )
    this.closeModalWithFileTypeCondition(arrayContainsFileType)
  }

  oldFactsheet(caseId): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    const array = this.oldFactsheetFile.split('.')
    const openableFormat = ['jpg', 'gif', 'pdf', 'png'];
    const arrayContainsFileType = (openableFormat.indexOf(array[array.length - 1].toLowerCase()) > -1);
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_factsheet&id=${caseId}`
    )
    this.closeModalWithFileTypeCondition(arrayContainsFileType)
  }

  oldMemo(caseId): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    const array = this.oldMemoFile.split('.')
    const openableFormat = ['jpg', 'gif', 'pdf', 'png'];
    const arrayContainsFileType = (openableFormat.indexOf(array[array.length - 1].toLowerCase()) > -1);
    this.cpmService
      .viewFileInIFrame(
        `${environment.cpmBaseUrl}/download?type=crm_memo&id=${caseId}`
      )
      .then(ret => {
        this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(ret)
        this.closeModalWithFileTypeCondition(arrayContainsFileType)
      })
  }

  get hasOldPresentationFileAtStart(): Boolean {
    return this.oldPresentationFile !== null && this.presentationFile === null
      ? true
      : false
  }

  get hasOldFactsheetFileAtStart(): Boolean {
    return this.oldFactsheetFile !== null && this.factsheetFile === null
      ? true
      : false
  }

  get hasOldMemoFileAtStart(): Boolean {
    return this.oldMemoFile !== null && this.memoFile === null ? true : false
  }

  get hasPresentationFile(): Boolean {
    return this.presentationFile === null ? true : false
  }

  get hasFactsheetFile(): Boolean {
    return this.factsheetFile === null ? true : false
  }

  get hasMemoFile(): Boolean {
    return this.memoFile === null ? true : false
  }

  get isUserHasMemoAccessPermission(): Boolean {
    return this.caseInformation !== undefined
      ? this.authorization.getUserDepartment() ===
      this.caseInformation.caseOwnerDepartmentId
      : false
  }

  disableFormControlIfNotPermitted() {
    if (this.caseInformation.caseOwnerFlag === 'Y') {
      return
    }

    this.caseForm.disable()
    if (this.isContinueCase()) {
      this.continueCaseSelectBoxComponent.disableFormControlIfNotPermitted()
    }
    this.setAttendeesComponent.disableFormControlIfNotPermitted()
    this.companyAttendeesComponent.disableFormControlIfNotPermitted()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/crm-edit-case/crm-edit-case.component.ts